var $menuToggle = document.querySelector('.navbar-toggle');
var $menu = document.querySelector('.menu');
var $menuItems = document.querySelectorAll('.menu-item');

window.onhashchange = function (){
  $menu.className = 'menu menu-no-transition';
}

for (var i = $menuItems.length - 1; i >= 0; i--) {
  $menuItems[i].onclick = function (){
    window.location.href='/#home';
  }
};

$menuToggle.onclick = function(){
  if($menu.className === 'menu active'){
    $menu.className = 'menu';
  } else {
    $menu.className = 'menu active';
  }
}



/*****************
 ** WEBPACK FOOTER
 ** ./js/main/navbar.js
 ** module id = 381
 ** module chunks = 2 4 5
 **/